import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Content, Main } from '../../../components/Layout';
import { Row, Col, Form } from 'react-bootstrap';
import Checkbox from '../../../components/Checkbox';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Wizard from '../../../components/Wizard';
import styleButton from '../../../components/Button/Button.module.css'
import Slct from '../../../components/Slct';
import Loading from '../../../components/Loading';
import { Cep, IntegerNumber, InputDocument, Phone } from '../../../components/Input';
import Required from '../../../components/Required';
import useWrapper from '../../../hooks/useWrapper'; 
import Button from '../../../components/Button';

export default function SuppliersRegister() {
  const { suppliersId } = useParams();
  
  const { me, config, setbreadcrumb } = useWrapper();

  const navigate = useNavigate();
  const permissions = JSON.parse(me.permissions);
  
  const [loadingPage, setLoadingPage] = useState(!!suppliersId)
  const [wizard, setWizard] = useState(1)
  const advanceStep = e => {
    let _error = [];
    document.querySelectorAll('.input-empty').forEach(e => {
      e.classList.remove('input-empty');
    })

    if(e > wizard || e === "save") {
      setTimeout(() => {
        if(e >= 2 || e === "save") {
          if(!suppliers.name) {
            _error.push({el: "suppliers.name", wiz: 1});
          }
          if(!suppliers.document_type) {
            _error.push({el: "suppliers.document_type", wiz: 1, parent: true});
          }
          // if(!suppliers.document) {
          //   _error.push({el: "suppliers.document", wiz: 1});
          // }
          if(suppliers.document_type === "cnpj" && !suppliers.state_registration) {
            _error.push({el: "suppliers.state_registration", wiz: 1, parent: true});
          }
          if(!suppliers.name_responsible) {
            _error.push({el: "suppliers.name_responsible", wiz: 1});
          }
          if(!suppliers.cell) {
            _error.push({el: "suppliers.cell", wiz: 1});
          }
          if(!suppliers.cep) {
            _error.push({el: "suppliers.cep", wiz: 1});
          }
          if(!suppliers.number) {
            _error.push({el: "suppliers.number", wiz: 1});
          }
          if(!suppliers.address) {
            _error.push({el: "suppliers.address", wiz: 1});
          }
          if(!suppliers.district) {
            _error.push({el: "suppliers.district", wiz: 1});
          }
          if(!suppliers.state_id) {
            _error.push({el: "suppliers.state_id", wiz: 1, parent: true});
          }
          if(!suppliers.city_id) {
            _error.push({el: "suppliers.city_id", wiz: 1, parent: true});
          }
        }
        if(e >= 3 || e === "save") {
          // if(!suppliers.payment.length) {
          //   _error.push({el: "suppliers.payments[]", wiz: 2, multi: true});
          // }
          if(suppliers.payment.some(e => e.label !== "Boleto" && e.label !== "PIX")) {
            if(suppliers.account.find(e => !e.bank)) {
              _error.push({el: "suppliers.account[].bank", wiz: 2});
            }
            if(suppliers.account.find(e => !e.ownership)) {
              _error.push({el: "suppliers.account[].ownership", wiz: 2, parent: true});
            }
            if(suppliers.account.find(e => !e.agency)) {
              _error.push({el: "suppliers.account[].agency", wiz: 2});
            }
            if(suppliers.account.find(e => !e.account)) {
              _error.push({el: "suppliers.account[].account", wiz: 2});
            }
            if(suppliers.account.find(e => !e.type)) {
              _error.push({el: "suppliers.account[].type", wiz: 2, parent: true});
            }
            if(suppliers.account.find(e => !e.document)) {
              _error.push({el: "suppliers.account[].document", wiz: 2});
            }
          }
          if(suppliers.payment.some(e => e.label === "PIX")) {
            if(!suppliers?.pix?.bank) {
              _error.push({el: "suppliers.pix.bank", wiz: 2});
            }
            if(!suppliers?.pix?.key) {
              _error.push({el: "suppliers.pix.key", wiz: 2});
            }
            if(!suppliers?.pix?.name) {
              _error.push({el: "suppliers.pix.name", wiz: 2});
            }
          }
        }
        if(_error.length > 0) {
          toast.error("Preencha todos os dados obrigatórios!");
          setWizard(_error[0].wiz);
        }
        else if(e === "save") {
          const _data = {
            name: suppliers.name,
            document_type: suppliers.document_type,
            document: suppliers.document,
            state_registration: suppliers.state_registration,
            name_responsible: suppliers.name_responsible,
            phone: suppliers.phone,
            cell: suppliers.cell,
            // is_whatsapp: suppliers.whatsapp,
            cell2: suppliers.cell2,
            email: suppliers.email,
            number: suppliers.number,
            address: suppliers.address,
            district: suppliers.district,
            complement: suppliers.complement,
            state_id: suppliers.state_id,
            city_id: suppliers.city_id,
            website: suppliers.website,
            cep: suppliers.cep,
            resources: suppliers.resources.map(e => e.value),
            payments: suppliers.payment.map(e => e.value),
            accounts: suppliers.account,
            fields: suppliers.field,
            pix_name: suppliers?.pix?.name,
            pix_key: suppliers?.pix?.key,
            pix_bank: suppliers?.pix?.bank
          }
          setloadingRequest(true);
          if(suppliersId) {
            api.put(`providers/${suppliersId}`, _data, config)
            .then(() => {
              setloadingRequest(false);
              toast.success("Fornecedor Editado com Sucesso!");
            })
          }
          else {
            api.post(`providers`, _data, config)
            .then(() => {
              setloadingRequest(false);
              toast.success("Fornecedor Adicionado com Sucesso!");
              navigate(`/suppliers`);
            })
          }
        }
        else {
          setWizard(e);
        }
        setTimeout(() => {
          _error.forEach(er => {
            if(er.wiz === _error[0].wiz && er.el) {
              if(er.parent) {
                document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                  el.parentElement.classList.add('input-empty')
                });
              }
              else if(er.multi) {
                document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                  el.parentElement.parentElement.classList.add('input-error')
                });
              }
              else {
                document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                  el.classList.add('input-empty');
                });
              }
            }
          })
        }, 200)
      }, 20)
    }
    else {
      setWizard(e);
    }
  }

  const [field, setField] = useState({
    title: '',
    description: ''
  });
  const [payments, setPayments] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [suppliers, setSuppliers] = useState({
    name: '',
    document_type: '',
    document: '',
    state_registration: '',
    name_responsible: '',
    phone: '',
    cell: '',
    cell2: '',
    email: '',
    number: '',
    address: '',
    district: '',
    complement: '',
    state_id: '',
    city_id: '',
    website: '',
    cep: '',
    account: [],
    field: [],
    payment: [],
    resources: []
  });

  useEffect(() => {
    if(suppliers) {
      if(suppliers.state_id) {
        api.get(`cities/${suppliers.state_id}`)
        .then(response => {
          let citiesVar = []
          response.data.forEach(e => {
            citiesVar.push({value: e.id, label: e.name, name: "city_id"})
          })
          setCities(citiesVar)
        })
      }
    }
  }, [suppliers.state_id])

  const [categories2, setcategories2] = useState();
  useEffect(() => {
    api.get('state')
    .then(response => {
      let statesVar = []
      response.data.forEach(e => {
        statesVar.push({value: e.id, label: e.name, name: "state_id", uf: e.uf})
      })
      setStates(statesVar)
    })
  
    api.get('payments', config)
    .then(response => {
      setPayments(response.data.data);
    })

    api.get('categories?only_attendance=0', config)
    .then(response => {
      setcategories2(response.data.data)
    })
    if(suppliersId){
      api.get(`providers/${suppliersId}`, config)
      .then(response => {
        setSuppliers({
          ...response.data,
          payment: response.data.payment.map(e => ({
            value: e.id,
            label: e.name
          })),
          resources: response.data.resources.map(e => ({
            value: e.id,
            label: e.name,
            category_id: e.category.id
          })),
          ...(!response.data.account.length && {
            account: []
          }),
          pix: {
            name: response.data.pix_name,
            key: response.data.pix_key,
            bank: response.data.pix_bank,
          }
        });
        if(response.data.state_id) {
          api.get(`cities/${response.data.state_id}`)
          .then(response => {
            let citiesVar = [{value: "", label: "-- Todos --", name: "city_id"}]
            response.data.forEach(e => {
              citiesVar.push({value: e.id, label: e.name, name: "city_id"})
            })
            setCities(citiesVar)
          })
        }
      })
      .then(() => {
        setLoadingPage(false)
      })
      .catch(error => {
        error.response.status === 401 && navigate('/no-permission');
      })
    }
  },[])

  useEffect(() => {
    setbreadcrumb([
      { label: "Fornecedores", url: "/suppliers" },
      {...suppliers.name ? { label: suppliers?.name } : { label: "Novo Fornecedor"}}
    ])
  }, [suppliers]);

  const [loadingRequest, setloadingRequest] = useState();

  return (
    <Main>
      {!loadingPage ? (
        <Content>
          <Row className="mb-3">
            <Col>
                <Wizard selected={wizard} options={[
                  {label: 'Dados de Cadastro', onClick: () => advanceStep(1) },
                  {label: 'Informações de Pagamento', onClick: () => advanceStep(2) },
                  {label: 'Recursos', onClick: () => advanceStep(3) }
                ]} />
            </Col>
          </Row>
          <Form id="suppliersForm">
          {wizard === 1 ? (  
          <Row className='inner-page__sbs-border mt-3'>
            <Col md={6}>
              <Row>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Nome ou Razão Social <Required /></span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            name: ev.target.value
                          })
                        }} 
                        name="suppliers.name" 
                        value={suppliers.name || ''}/>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col sm={6}>
                  <Form.Group>
                    <span className='lince-input_label'>Tipo de Registro <Required /></span>
                    <div className='lince-input__text'>
                    <Slct
                      isDisabled={!permissions.suppliers.update}
                      options={[{value: "cpf", label: "Pessoa Física"}, {value: "cnpj", label: "Pessoa Jurídica", name: "document_type"}]}
                      value={suppliers.document_type || ''}
                      onChange={e => {
                        setSuppliers({
                          ...suppliers, 
                          document_type: e.value
                        });
                      }}
                      placeholder="..."
                      name="suppliers.document_type"
                    />
                    </div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  {suppliers.document_type && (
                    <Form.Group>
                      <span className='lince-input_label'>{suppliers.document_type === "cnpj" ? "CNPJ" : "CPF" }</span>
                      <InputDocument
                        disabled={!permissions.suppliers.update}
                        value={suppliers.document || ''}
                        type={suppliers.document_type}
                        name="suppliers.document"
                        valueChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            document: ev
                          })
                        }}
                      />
                    </Form.Group>
                  )}
                </Col>
              </Row>
              <Row className='mt-2'>
                {suppliers.document_type === "cnpj" && (
                  <Col>
                      <Form.Group className='lince-input' controlId="validationCustom01">
                        <span className='lince-input_label'>Inscrição Estadual <Required /></span>
                        <div className='lince-input__text'>
                          <Slct
                            isDisabled={!permissions.suppliers.update}
                            options={states.map(e => ({value: e.uf, label: e.uf}))}
                            value={suppliers.state_registration || ''}
                            name="suppliers.state_registration"
                            onChange={ev => {
                              setSuppliers({
                                ...suppliers,
                                state_registration: ev.value
                              })
                            }}
                            placeholder="..."
                          />
                        </div>
                      </Form.Group>
                  </Col>
                )}
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Nome do Responsável <Required /></span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            name_responsible: ev.target.value
                          })
                        }} 
                        name="suppliers.name_responsible" 
                        value={suppliers.name_responsible || ''}/>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input checkbox-input'>
                    <span className='lince-input_label'>Celular <Required /></span>
                    <Phone
                      disabled={!permissions.suppliers.update}
                      value={suppliers.cell || ''}
                      name="suppliers.cell"
                      valueChange={ev => {
                        setSuppliers({
                          ...suppliers,
                          cell: ev
                        })
                      }}
                    />
                    <Form.Check.Label className='im-checkbox'>
                      <Checkbox 
                        disabled={!permissions.suppliers.update}
                        colorScheme="primary"
                        name="is_whatsapp"
                        checked={suppliers.whatsapp}
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            whatsapp: ev.target.checked
                          })
                        }}
                      />
                      <span className='lince-input_label fs-12'>WhatsApp?</span>
                    </Form.Check.Label>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Telefone</span>
                    <div className='lince-input__text'>
                      <Phone
                        disabled={!permissions.suppliers.update}
                        value={suppliers.phone || ''}
                        name="suppliers.phone"
                        valueChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            phone: ev
                          })
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input checkbox-input'>
                    <span className='lince-input_label'>Celular 2</span>
                    <div className='lince-input__text'>
                      <Phone
                        disabled={!permissions.suppliers.update}
                        value={suppliers.cell2 || ''}
                        valueChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            cell2: ev
                          })
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>E-mail</span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            email: ev.target.value
                          })
                        }}
                        value={suppliers.email || ''}
                        name="suppliers.email"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col>
                  <Form.Group className='lince-input nav-input'>
                    <div className="d-flex">
                      <span className='lince-input_label'>CEP <Required /></span>
                      <a href="https://buscacepinter.correios.com.br/app/endereco/index.php?t" rel="noopener noreferrer" target="_blank" className="im-nav">Buscar CEP</a>
                    </div>
                    <div className='lince-input__text'>
                      <Cep 
                        disabled={!permissions.suppliers.update}
                        value={suppliers.cep || ''}
                        valueChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            cep: ev
                          })
                        }}
                        name="suppliers.cep"
                        onBlur={() => {
                          if(String(suppliers.cep).length >= 8) {
                            api.get(`https://viacep.com.br/ws/${suppliers.cep}/json/`)
                            .then(response => {
                              let _state = states.find(e => e.uf === response.data.uf) || null;

                              if(_state) {
                                _state.value && api.get(`cities/${_state.value}`)
                                .then(response2 => {
                                  let _city = response2.data.find(e => e.name === response.data.localidade) || null;
                                  setSuppliers({
                                    ...suppliers,
                                    address: response.data.logradouro,
                                    district: response.data.bairro,
                                    city_id: _city.id,
                                    state_id: _city.state_id
                                  });
                                })
                              }
                            })
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Número <Required /></span>
                    <div className='lince-input__text'>
                      <IntegerNumber 
                        disabled={!permissions.suppliers.update}
                        value={suppliers.number || ''}
                        valueChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            number: ev
                          })
                        }}
                        name="suppliers.number"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Endereço <Required /></span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            address: ev.target.value
                          })
                        }}
                        value={suppliers.address || ''}
                        name="suppliers.address"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Bairro <Required /></span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            district: ev.target.value
                          })
                        }}
                        value={suppliers.district || ''}
                        name="suppliers.district"
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Complemento</span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            complement: ev.target.value
                          })
                        }}
                        value={suppliers.complement || ''}/>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input'>
                    <span className='lince-input_label'>Estado <Required /></span>
                    <Slct
                      isDisabled={!permissions.suppliers.update}
                      options={states}
                      value={suppliers.state_id || ''}
                      onChange={ev => {
                        setSuppliers({
                          ...suppliers,
                          state_id: ev.value,
                          city_id: null
                        })
                      }}
                      placeholder="..."
                      name="suppliers.state_id"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='lince-input'>
                    <span className='lince-input_label'>Cidade <Required /></span>
                    <Slct
                      isDisabled={!permissions.suppliers.update}
                      options={cities}
                      value={suppliers.city_id || ''}
                      onChange={e => {
                        setSuppliers({
                          ...suppliers, 
                          city_id: e.value
                        });
                      }}
                      placeholder="..."
                      name="suppliers.city_id"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <Form.Group className='lince-input' controlId="validationCustom01">
                    <span className='lince-input_label'>Site</span>
                    <div className='lince-input__text'>
                      <Form.Control 
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setSuppliers({
                            ...suppliers,
                            website: ev.target.value
                          })
                        }}
                        value={suppliers.website || ''}/>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          ) 
          : wizard === 2 ? (
          <>  
          <Row className='inner-page__sbs-border mt-3'>
            <Col md={6} className='pr-md-5'>
              <Row className="mb-4">
                <Col>
                  <span className='lince-input_label lince-input_label-gray mb-2'>Aceita pagamentos em:</span>
                  <Slct 
                    isDisabled={!permissions.suppliers.update}
                    className="w-100"
                    isMulti="true"
                    placeholder="..."
                    name="suppliers.payments[]"
                    value={suppliers.payment || []}
                    options={[
                      { label: "Espécie", value: 1 },
                      { label: "Transferência", value: 2 },
                      { label: "Boleto", value: 3 },
                      { label: "Cartão", value: 4 },
                      { label: "PIX", value: 5 }
                    ]}
                    // options={payments.map(e => ({
                    //   label: e.name,
                    //   value: e.id
                    // }))}
                    onChange={
                      el => {
                        setSuppliers({
                          ...suppliers,
                          payment: el
                        });
                      }
                    }
                  />
                </Col>
              </Row>
              {suppliers.payment.some(e => e.label === "PIX") && (
                <div style={{borderLeft: "var(--color-grey-3) 3px solid", paddingLeft: "1rem", marginBottom: "1.5rem"}}>
                  <Row className="mb-2">
                    <Col className="d-flex justify-content-between">
                      <span className="d-inline-block mr-3 mini-title">Dados do PIX</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Form.Group>
                        <span className='lince-input_label'>Chave PIX <Required /></span>
                        <div className='lince-input__text'>
                          <Form.Control
                            disabled={!permissions.suppliers.update}
                            type='text' 
                            onChange={__ev => {
                              setSuppliers({
                                ...suppliers,
                                pix: {
                                  ...suppliers.pix,
                                  key: __ev.target.value
                                }
                              })
                            }} 
                            name="suppliers.pix.key" 
                            value={suppliers?.pix?.key}/>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <span className='lince-input_label'>Banco <Required /></span>
                        <div className='lince-input__text'>
                          <Form.Control
                            disabled={!permissions.suppliers.update}
                            type='text' 
                            onChange={__ev => {
                              setSuppliers({
                                ...suppliers,
                                pix: {
                                  ...suppliers.pix,
                                  bank: __ev.target.value
                                }
                              })
                            }} 
                            name="suppliers.pix.bank" 
                            value={suppliers?.pix?.bank}/>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col sm={12} className='mt-2'>
                      <Form.Group>
                        <span className='lince-input_label'>Nome <Required /></span>
                        <div className='lince-input__text'>
                          <Form.Control
                            disabled={!permissions.suppliers.update}
                            type='text' 
                            onChange={__ev => {
                              setSuppliers({
                                ...suppliers,
                                pix: {
                                  ...suppliers.pix,
                                  name: __ev.target.value
                                }
                              })
                            }} 
                            name="suppliers.pix.name" 
                            value={suppliers?.pix?.name}/>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}
              {suppliers.payment.some(e => e.label !== "Boleto" && e.label !== "PIX") && (
                <>
                  {suppliers.account.map((e, i) => (
                    <div style={{borderLeft: "var(--color-grey-3) 3px solid", paddingLeft: "1rem", marginBottom: "1.5rem"}}>
                      <Row className="mb-2">
                        <Col className="d-flex justify-content-between">
                            <span className="d-inline-block mr-3 mini-title">Conta Bancária</span>
                              <button 
                              type="button" 
                              onClick={() => {
                                let _accounts = [...suppliers.account];
                                _accounts.splice(i, 1);
                                setSuppliers({
                                  ...suppliers,
                                  account: _accounts
                                })
                              }}
                              className={styleButton.button_error_soft}> 
                                  <span>Remover</span>
                              </button> 
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Group>
                            <span className='lince-input_label'>Banco <Required /></span>
                            <div className='lince-input__text'>
                            <Form.Control
                              disabled={!permissions.suppliers.update}
                              type='text' 
                              onChange={ev => {
                                let _accounts = [...suppliers.account];
                                _accounts[i].bank = ev.target.value;
                                setSuppliers({
                                  ...suppliers,
                                  account: _accounts
                                })
                              }} 
                              name="suppliers.account[].bank" 
                              value={e.bank}/>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <span className='lince-input_label'>Titularidade <Required /></span>
                            <div className='lince-input__select'>
                              <Slct
                                isDisabled={!permissions.suppliers.update}
                                options={[{value: "cpf", label: "Pessoa Física"},{value: "cnpj", label: "Pessoa Jurídica"}]}
                                className="w-100"
                                onChange={ev => {
                                  let _accounts = [...suppliers.account];
                                  _accounts[i].ownership = ev.value;
                                  setSuppliers({
                                    ...suppliers,
                                    account: _accounts
                                  })
                                }}
                                value={e.ownership}
                                placeholder="..."
                                name="suppliers.account[].ownership" 
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className='mt-2'>
                        <Col>
                          <Form.Group>
                            <span className='lince-input_label'>Agência <Required /></span>
                            <div className='lince-input__text'>
                            <Form.Control
                              disabled={!permissions.suppliers.update}
                              type='text' 
                              onChange={ev => {
                                let _accounts = [...suppliers.account];
                                _accounts[i].agency = ev.target.value;
                                setSuppliers({
                                  ...suppliers,
                                  account: _accounts
                                })
                              }}
                              value={e.agency}
                              name="suppliers.account[].agency" 
                            />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <span className='lince-input_label'>Conta <Required /></span>
                            <div className='lince-input__text'>
                            <Form.Control
                              disabled={!permissions.suppliers.update}
                              type='text' 
                              onChange={ev => {
                                let _accounts = [...suppliers.account];
                                _accounts[i].account = ev.target.value;
                                setSuppliers({
                                  ...suppliers,
                                  account: _accounts
                                })
                              }} 
                              name="suppliers.account[].account"
                              value={e.account}/>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className='mt-2'>
                        <Col>
                          <Form.Group>
                            <span className='lince-input_label'>Tipo de Conta <Required /></span>
                            <Slct
                              isDisabled={!permissions.suppliers.update}
                              options={[{value: "cc", label: "Conta Corrente"}, {value: "cp", label: "Conta Poupança"}]}
                              className="w-100"
                              onChange={ev => {
                                let _accounts = [...suppliers.account];
                                _accounts[i].type = ev.value;
                                setSuppliers({
                                  ...suppliers,
                                  account: _accounts
                                })
                              }}
                              value={e.type}
                              placeholder="..."
                              name="suppliers.account[].type"
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          {e.ownership && (
                            <Form.Group>
                              <span className='lince-input_label'>{e.ownership === "cpf" ? "CPF" : "CNPJ"} <Required /></span>
                              <div className='lince-input__text'>
                                <InputDocument
                                  disabled={!permissions.suppliers.update}
                                  value={e.document || ''}
                                  type={e.ownership}
                                  name="suppliers.account[].document"
                                  valueChange={ev => {
                                    let _accounts = [...suppliers.account];
                                    _accounts[i].document = ev;
                                    setSuppliers({
                                      ...suppliers,
                                      account: _accounts
                                    })
                                  }}
                                />
                              </div>
                            </Form.Group>
                          )}
                        </Col>
                      </Row>
                    </div>
                  ))}
                  {permissions.suppliers.update && (
                    <Row className='mt-2'>
                      <Col>
                        <button
                          type="button"
                          className={styleButton.button_success_soft}
                          onClick={() => {
                            setSuppliers({
                              ...suppliers,
                              account: [
                                ...suppliers.account,
                                {
                                  bank: "",
                                  ownership: "",
                                  agency: "",
                                  account: "",
                                  type: "",
                                  document: ""
                                }
                              ]
                            })
                          }}
                        >
                          <span>
                            Adicionar Conta
                          </span>
                        </button>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Col>
            <Col sm={6} className="border-left pl-5 observations">
              <h3 className="d-inline-block mb-2 mini-title">Descrições & Observações</h3>
                <p className='small-label mb-3'>Personalize os campos abaixo e complemente o perfil do seu fornecedor adicionando informações relevantes como: lotação de espaços, material disponível, produtos mais utilizados, etc. Tudo que há de importante na negociação em um só lugar.</p>
                <Row>
                  <Col>
                    <Form.Group>
                      <input
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setField({
                            ...field,
                            title: ev.target.value
                          })
                        }}
                        value={field.title}
                        name="field.title"
                        placeholder='Título'
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col>
                    <Form.Group>
                      <input
                        disabled={!permissions.suppliers.update}
                        type='text' 
                        onChange={ev => {
                          setField({
                            ...field,
                            description: ev.target.value
                          })
                        }}
                        value={field.description}
                        name="field.description" 
                        placeholder='Descrição'/>
                    </Form.Group>
                  </Col>
                </Row>
                {permissions.suppliers.update && (
                  <Row className='mt-2'>
                    <Col>
                      <div className="mb-4 pb-4 border-bottom">
                        <button
                          type="button"
                          className={styleButton.button_success_soft}
                          onClick={() => {
                            let _error = [];
                            document.querySelectorAll('.observations .input-empty').forEach(e => {
                              e.classList.remove('input-empty');
                            })
                            if(!field.title) {
                              _error.push({el: "field.title"});
                            }
                            if(!field.description) {
                              _error.push({el: "field.description"});
                            }
                            if(_error.length > 0) {
                              _error.forEach(er => {
                                setTimeout(() => {
                                  document.querySelectorAll(`.observations *[name="${er.el}"]`).forEach(el => {
                                    el.classList.add('input-empty');
                                  })
                                }, 20)
                              })
                              toast.error("Preencha todos os dados obrigatórios!");
                            }
                            else {
                              setSuppliers({
                                ...suppliers,
                                field: [
                                  ...suppliers.field,
                                  {
                                    description: field.description,
                                    title: field.title
                                  }
                                ]
                              })
                              setField({title:'',description:''})
                            }
                          }}
                        >
                          <span>Adicionar Observação</span>
                        </button>
                      </div>
                    </Col>
                  </Row>
                )}
              {suppliers.field.map((e, i) => (
                <Row className="mb-4">
                  <Col style={{borderLeft: "var(--color-grey-3) 3px solid", paddingLeft: "1rem", paddingBottom: "1rem"}}>
                    <div className="labelPersonalizacao">
                      <Form.Group className="d-flex justify-content-between">
                        <span className="d-flex align-items-center">{e.title}</span>
                        <button 
                          type="button" 
                          onClick={() => {
                            let _field = [...suppliers.field];
                            _field.splice(i, 1);
                            setSuppliers({
                              ...suppliers,
                              field: _field
                            })
                          }} 
                          className={styleButton.button_error_soft}
                        >
                          <span>Remover</span>
                        </button> 
                      </Form.Group>
                    </div>
                    <div className='mt-2'>
                      <input type='text' value={e.description}/>
                    </div>
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
          </>
          ):
          wizard === 3 ? (
          <Row>  
            <h3 className="d-inline-block mb-2 mini-title">Recursos</h3>
            <p className='small-label mb-2'>Personalize os campos abaixo e complemente o perfil do seu fornecedor adicionando recursos que ele está relacionado.</p>
            {categories2.map(e => (
              <Col md={6} className='mt-2'>
                <Form.Group>
                  <span className='lince-input_label'>{e.name}</span>
                  <Slct
                    isDisabled={!permissions.suppliers.update}
                    isMulti="true"
                    options={e.resource.map(e2 => ({
                      value: e2.id,
                      label: e2.name,
                      category_id: e.id
                    }))}
                    placeholder="..."
                    value={suppliers.resources.filter(e2 => e2.category_id === e.id)}
                    onChange={ev => {
                      let _other_resources = [...suppliers.resources.filter(e2 => e2.category_id !== e.id)];
                      setSuppliers({
                        ...suppliers,
                        resources: _other_resources.concat(ev)
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            ))}
            {/* {resourcesDOM} */}
          </Row>
          ) : (<></>)}
          <Row className='inner-page__actions mt-3'>
            <Col className='d-flex justify-content-between'>
              <div className='inner-page__actions__group'>
                {wizard > 1 && (
                  <Button
                    color="primary_ghost"
                    loading={loadingRequest}
                    onClick={() => advanceStep(wizard-1)}
                  >
                    Voltar
                  </Button>
                )}
              </div>
              <div className='text-right'>
                {wizard <= 2 && (
                  <Button
                    color="primary_ghost"
                    loading={loadingRequest}
                    onClick={() => advanceStep(wizard+1)}
                  >
                    Avançar
                  </Button>
                )
                }
                {(suppliersId || wizard >= 3 ) && (
                  <>
                    {permissions.suppliers.update && (
                      <Button
                        loading={loadingRequest}
                        onClick={() => {advanceStep("save")}}
                      >
                        Salvar
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
          </Form>        
        </Content>
      ):(
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
